import { render, staticRenderFns } from "./tableTopButton.vue?vue&type=template&id=70608d46"
import script from "./tableTopButton.vue?vue&type=script&lang=js"
export * from "./tableTopButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports